<template>
  <div :class="utdLogoClass">
    <a class="wk-logo"
       aria-label="UpToDate logo"
       href="/contents/search"
       tabindex="0">
      <img :src="wkWheelIconSrc" class="wk-wheel" alt="Wolters Kluwer"><!--
   --><img :src="utdLogoSrc" class="utd-logo" alt="UpToDate">
    </a>
    <span v-if="showCoBranding"
          id="cobrandingLogoRes"
          class="cobrandingLogoRes">
      <a :href="cobrandingAnchorHref"
         aria-label="Co-branding logo"
         target="_blank"
         tabindex="0"
         rel="noopener noreferrer">
        <img :src="cobrandingImageUrl" alt="Co-brand Logo">
      </a>
    </span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { C_APP } from '_acaSrc/utility/constants';
import menuUtdLogo from '~_acaAssets/utd-menu/utd-logo.svg';
import menuUtdCcLogo from '~_acaAssets/utd-menu/utdcc-logo.svg';
import menuWheelIcon from '~_acaAssets/utd-menu/wk-wheel-icon.svg';
import redesignUtdLogo from '~_acaAssets/utd-redesign/utd-logo.svg';
import redesignUtdCcLogo from '~_acaAssets/utd-redesign/utdcc-logo.svg';
import redesignWheelIcon from '~_acaAssets/utd-redesign/wk-wheel-icon-white.svg';

export default {
    props: {
        darkLogo: {
            required: false,
            type: Boolean,
            default: true
        }
    },
    computed: {
        ...mapGetters('app', [
            'isUccState',
            'cobrandingImageUrl',
            'cobrandingAnchorHref',
            'showCoBranding'
        ]),
        ...mapGetters('feature', [ 'isHomepageRedesign2024' ]),
        utdLogoClass() {
            return this.isUccState
                ? C_APP.LOGO_FILENAMES.UCC
                : '';
        },
        utdLogoSrc() {
            const shouldUseRedesignLogo = this.isHomepageRedesign2024 && !this.darkLogo;
            if (shouldUseRedesignLogo) {
                return this.isUccState ? redesignUtdCcLogo : redesignUtdLogo;
            }

            return this.isUccState ? menuUtdCcLogo : menuUtdLogo;
        },
        wkWheelIconSrc() {
            return this.isHomepageRedesign2024 && !this.darkLogo
                ? redesignWheelIcon
                : menuWheelIcon;
        }
    }
};
</script>

<style lang="less">
@import './UtdLogo.less';

.wk-logo {
  &:focus-visible {
    outline: none;
  }
}

&.utdWkHomePage2024 {
  .isSmallScreen&,
  .isMobile&,
  .isMobileOnDesktop&,
  .isTablet& {
    .wk-logo {
      .wk-wheel {
        width: 36px;
        height: 36px;
        margin-right: 12px;
      }

      .utd-logo {
        height: 36px;
        width: auto;
      }
    }
  }
}
</style>
